import script from "./header-edit-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./header-edit-dialog.vue?vue&type=script&setup=true&lang=js"

import "./header-edit-dialog.vue?vue&type=style&index=0&id=b94d6cb0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b94d6cb0"]])

export default __exports__